import { cn } from "@/lib/utils";

/** A green dot that pulses: someone is at work right now. */
export function PulseDot({ className, label }: { className?: string; label?: string }) {
  return (
    <span
      className={cn("relative flex h-2.5 w-2.5 shrink-0", className)}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-60" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" />
    </span>
  );
}
